import { FC } from 'react';
import type { TechnicalErrorWithPriceTileData } from 'state/quotes/dashboard/model';

import { Price, PricingDate, ResultPanel, SolveModeLabel, TechnicalError, TileLayout } from './components';
import type { TileContentProps } from './Tile.common';
export const TechnicalErrorWithPriceTile: FC<TileContentProps<TechnicalErrorWithPriceTileData>> = ({
  quoteId,
  data,
  header,
  subHeader,
  footer,
}) => {
  return (
    <TileLayout header={header} subHeader={subHeader} footer={footer}>
      <ResultPanel
        color="danger"
        solveModeLabel={<SolveModeLabel value={data.solveMode} size="small" />}
        price={
          data.solveResult !== undefined &&
          data.xMargin !== undefined && (
            <Price
              solveResult={data.solveResult}
              solveResultFormat={data.solveResultFormat}
              xMargin={data.xMargin}
              color="danger"
            />
          )
        }
        statusPanel={<TechnicalError id={quoteId} value={data.errorMessage} />}
        subHeader={<PricingDate when={data.lastUpdated} />}
      />
    </TileLayout>
  );
};

TechnicalErrorWithPriceTile.displayName = 'TechnicalErrorWithPriceTile';
